import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Page-level SEO metadata (currently description only).
 * Uses react-helmet-async to inject tags into <head> without affecting layout.
 *
 * @param {{ description?: string }} props
 * @returns {JSX.Element | null}
 */
const PageMeta = ({ description }) => {
  if (!description) {
    return null;
  }

  return (
    <Helmet>
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default PageMeta;

